import QuickBooksConnectDialog from "./quickbooksConnectDialog";

export default function QuickBooksDialogs({
  openDialog,
  data,
  closeDialog,
  onConnect,
  onDisconnect,
}) {
  switch (openDialog) {
    case "connect":
      return (
        <QuickBooksConnectDialog
          data={data}
          onClose={closeDialog}
          onConnect={onConnect}
          onDisconnect={onDisconnect}
        />
      );
    default:
      return null;
  }
}